<script setup lang="ts">
import { useThrottleFn } from '@vueuse/core'
import Button from '@/core/components/base/Button.vue'
import { useButtonFlipup, useButtonFlipupMock } from './ButtonFlipup'
import LanguageView from '@/core/components/LanguageView.vue'

const { disabled, doFlipUp } = useButtonFlipup()

const handleTap = useThrottleFn((event: PointerEvent) => {
  doFlipUp()
}, 250)
</script>

<template>
  <Button class="button-flipup" :disabled @tap="handleTap">
    <template #default><img src="/images/simakatra/arrow-up.gif" /></template>
    <template #disabled><img src="/images/simakatra/arrow-up-disable.png" /></template>
  </Button>
</template>

<style scoped>
.button-flipup {
  position: absolute;
  top: 973px;
  left: 653px;
}
</style>
